import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wishlist-ld" }
const _hoisted_2 = { class: "wishlist-ld__body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center h1" }, "Lock Designer Wishlist", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = { class: "wishlist-ld__top-bar" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "mb-5 text-center p-3 bg-gray-light"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("You dont currently have any lock designer wishlists. These can be be added by going to ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "/lock-designer" }, "Lock Designer", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" and clicking the \"Add to Wishlist\" button")
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "product-grid mb-5 product-grid--4-col"
}

interface Window {
	dataLayer: any[];
}
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
import {WishlistItems, WishlistItemsToAdd} from "Api/apis";
import WishlistCard from "Vue/components/shared/WishlistCard.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const wishlistItems = ref([]);
const wishlists = ref([]);
const selectedWishlist = ref('');
const componentName = 'WishlistLockDesigner';

const isLoggedIn = computed(() => {
	return !!store?.state?.authToken;
});

const setFirstWishlistItem = () => {
	if (wishlists.value.length > 0) {
		selectedWishlist.value = wishlists.value[0] || '';
	}
};

const itemDeleted = async(isLastItem) => {
	//get the list of wishlists again and set it to the first item if the wishlist was entirely deleted
	if(isLastItem) {
		await getWishlistList();
	}

	await updateWishlist();
}

const updateWishlist = async() => {
	if(isLoggedIn.value) {
		const itemRequest = {
			wishlistName: selectedWishlist.value
		}
		let response = await WishlistItems(itemRequest, store?.state?.authToken);

		if(!response.isErrors) {
			wishlistItems.value = response.data?.items;
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'wishlistUser',
				data: response.data?.username
			});
		} else {
			//has errors
			console.log('no wishlist items data')
		}
	}
}

const getWishlistList = async() => {
	const lockDesignerWishlistItemsToAddRequest = {
		selections: store?.state?.selections,
		wishlistName: ''
	};
	const authToken = store?.state?.authToken;
	let items = await WishlistItemsToAdd(lockDesignerWishlistItemsToAddRequest, authToken);

	if(!items.isErrors) {
		wishlists.value = items.data?.wishlists;
	}

	setFirstWishlistItem();
	await updateWishlist();
};


watch(isLoggedIn, async(newValue, oldValue) => {
	if(newValue === true) {
		await getWishlistList();
	}
});

const login = async() => {
	await router.push('/wishlist/login');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_unref(isLoggedIn))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(Cta, {
              type: "primary",
              size: "lg",
              label: "Log In / Create Account",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (login())),
              icon: [],
              iconAlignment: "left"
            })
          ]))
        : _createCommentVNode("v-if", true),
      (_unref(isLoggedIn))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              (wishlists.value.length)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    name: "wishlistSelection",
                    id: "wishlistSelection",
                    class: _normalizeClass([`custom-select wishlist-ld__select`]),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedWishlist).value = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (updateWishlist()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wishlists.value, (wishlist) => {
                      return (_openBlock(), _createElementBlock("option", { value: wishlist }, _toDisplayString(wishlist), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)), [
                    [_vModelSelect, selectedWishlist.value]
                  ])
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
            ]),
            (wishlistItems.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wishlistItems.value, (wishlistItem, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: wishlistItem.id,
                      class: "product-grid__item"
                    }, [
                      _createVNode(WishlistCard, {
                        displayName: wishlistItem.displayName,
                        finishDisplayName: wishlistItem.finishDisplayName,
                        id: wishlistItem.id,
                        imageUrl: wishlistItem.imageUrl+`?wid=400`,
                        url: wishlistItem.url,
                        itemsLength: wishlistItems.value.length,
                        onItemDeleted: itemDeleted
                      }, null, 8 /* PROPS */, ["displayName", "finishDisplayName", "id", "imageUrl", "url", "itemsLength"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})